<template>
  <router-link 
    :to="route" 
    class="block bg-black-800 rounded-2xl p-8 border border-gold-800 transform transition-all duration-500 hover:scale-105 hover:border-gold-500 group"
  >
    
    <h3 class="text-2xl font-display font-bold text-gold-400 mb-4 transform transition-all duration-300 group-hover:translate-x-2">
      {{ title }}
    </h3>
    
    <p class="text-gray-300 mb-6">
      {{ description }}
    </p>
    
    <div class="flex items-center text-gold-400 font-medium mt-6">
      <span>Explore Products</span>
      <svg class="w-5 h-5 ml-2 transform transition-transform duration-300 group-hover:translate-x-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
      </svg>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'ServiceCategoryCard',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    route: {
      type: String,
      required: true
    }
  }
}
</script>